import React, { useState, useEffect } from "react";
import plus from "../../assets/images/fi_plus.svg";
import edit from "../../assets/images/u_edit-alt.svg";
import trash from "../../assets/images/fi_trash.svg";

function CommentSection({
  logic,
  setLogic,
  recommendation,
  setRecommendation,
  updateLogicRecommendation,
}) {
  const [inputValueLogic, setInputValueLogic] = useState(""); 
  const [inputValueRecommendation, setInputValueRecommendation] = useState(""); 

  useEffect(() => {
    updateLogicRecommendation();
  }, [logic, recommendation]);

  
  const addLogic = () => {
    if (inputValueLogic.trim() !== "") {
      setLogic([
        ...logic,
        { id: Date.now(), text: inputValueLogic, isEditing: false },
      ]);
      setInputValueLogic(""); 
    }
  };

  const handleKeyDownLogic = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); 
      addLogic(); 
    }
  };

  const handleKeyDownRecommendation = (e) => {
    
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); 
      addRecommendation(); 
    }
  };

  const addRecommendation = () => {
    if (inputValueRecommendation.trim() !== "") {
      setRecommendation([
        ...recommendation,
        { id: Date.now(), text: inputValueRecommendation, isEditing: false },
      ]);
      setInputValueRecommendation(""); 
    }
  };

  const handleLogicChange = (id, text) => {
    setLogic(
      logic.map((logic) => {
        if (logic.id === id) {
          return { ...logic, text };
        }
        return logic;
      })
    );
  };

  const handleRecommendationChange = (id, text) => {
    setRecommendation(
      recommendation.map((recommendation) => {
        if (recommendation.id === id) {
          return { ...recommendation, text };
        }
        return recommendation;
      })
    );
  };

  // Toggles the isEditing state of a logic
  const toggleEditLogic = (id) => {
    setLogic(
      logic.map((logic) => {
        if (logic.id === id) {
          return { ...logic, isEditing: !logic.isEditing };
        }
        return logic;
      })
    );
  };

  const toggleEditRecommendation = (id) => {
    setRecommendation(
      recommendation.map((recommendation) => {
        if (recommendation.id === id) {
          return { ...recommendation, isEditing: !recommendation.isEditing };
        }
        return recommendation;
      })
    );
  };

  const deleteLogic = (id) => {
    setLogic(logic.filter((logic) => logic.id !== id));
  };
  const deleteRecommendation = (id) => {
    setRecommendation(
      recommendation.filter((recommendation) => recommendation.id !== id)
    );
  };

  return (
    <>
      <div className="flex flex-col items-start gap-5 self-stretch">
        <div className="text-[#454545] font-roboto text-base font-normal">
          Trade Call Logic
        </div>
        <div className="flex flex-col gap-1 w-full">
          <div className="flex flex-col sm:flex-row items-stretch sm:items-start gap-3 sm:gap-5 self-stretch">
            <textarea
              value={inputValueLogic}
              onChange={(e) => setInputValueLogic(e.target.value)}
              onKeyDown={handleKeyDownLogic}
              placeholder="Enter Your Logic For This Call"
              maxLength={250}
              className="flex w-full h-32 resize-none py-2.5 px-3 items-start gap-2 rounded-lg border border-brand-border bg-white text-[#939393] font-roboto text-base font-normal"
            />
            <img
              src={plus}
              alt="Add"
              onClick={addLogic}
              className="flex w-[46px] h-11 p-2.5 justify-center items-center gap-1 rounded-lg border border-[#1569AB] cursor-pointer self-end sm:self-auto"
            />
          </div>
          <div className="text-right text-xs text-gray-400">
            {inputValueLogic.length}/250
          </div>
        </div>

        <div className="flex flex-col items-start gap-3 self-stretch w-full">
          {logic?.map((item) => (
            <div
              key={item.id}
              className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 self-stretch w-full"
            >
              <input
                type="text"
                value={item.text}
                readOnly={!item.isEditing}
                onChange={(e) => handleLogicChange(item.id, e.target.value)}
                className={`flex w-full sm:flex-1 min-w-0 p-3 items-center gap-2 rounded-lg border border-brand-border text-[#939393] font-roboto text-base font-normal ${
                  item.isEditing
                    ? "bg-white cursor-text"
                    : "bg-transparent cursor-default"
                }`}
              />
              <div className="flex items-start gap-3 flex-wrap sm:flex-nowrap">
                <div
                  className="cursor-pointer font-roboto text-[0.9rem] font-normal text-[#1567A7] flex items-center"
                  onClick={() => toggleEditLogic(item.id)}
                >
                  <img src={edit} alt="Edit" className="w-4 h-4 ml-1" /> Edit
                </div>
                <div
                  className="cursor-pointer font-roboto text-[0.9rem] font-normal text-brand-red flex items-center"
                  onClick={() => deleteLogic(item.id)}
                >
                  <img src={trash} alt="Delete" className="w-4 h-4 ml-1" />{" "}
                  Delete
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="w-full h-[0.6px] bg-[#d9d9d9]" />

      <div className="flex flex-col items-start gap-5 self-stretch">
        <div className="text-[#454545] font-roboto text-base font-normal">
          Recommendation on Trade call
        </div>

        <div className="flex flex-col gap-1 w-full">
          <div className="flex flex-col sm:flex-row items-stretch sm:items-start gap-3 sm:gap-5 self-stretch">
            <textarea
              value={inputValueRecommendation}
              onChange={(e) => setInputValueRecommendation(e.target.value)}
              onKeyDown={handleKeyDownRecommendation}
              placeholder="Enter your Recommendations"
              maxLength={250}
              className="flex w-full h-32 resize-none py-2.5 px-3 items-start gap-2 rounded-lg border border-brand-border bg-white text-[#939393] font-roboto text-base font-normal"
            />
            <img
              src={plus}
              alt="Add"
              onClick={addRecommendation}
              className="flex w-[46px] h-11 p-2.5 justify-center items-center gap-1 rounded-lg border border-[#1569AB] cursor-pointer self-end sm:self-auto"
            />
          </div>
          <div className="text-right text-xs text-gray-400">
            {inputValueRecommendation.length}/250
          </div>
        </div>

        <div className="flex flex-col items-start gap-3 self-stretch w-full">
          {recommendation?.map((recommendation) => (
            <div
              key={recommendation.id}
              className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 self-stretch w-full"
            >
              <input
                type="text"
                value={recommendation.text}
                readOnly={!recommendation.isEditing}
                onChange={(e) =>
                  handleRecommendationChange(recommendation.id, e.target.value)
                }
                className={`flex w-full sm:flex-1 min-w-0 p-3 items-center gap-2 rounded-lg border border-brand-border text-[#939393] font-roboto text-base font-normal ${
                  recommendation.isEditing
                    ? "bg-white cursor-text"
                    : "bg-transparent cursor-default"
                }`}
              />
              <div className="flex items-start gap-3 flex-wrap sm:flex-nowrap">
                <div
                  className="cursor-pointer font-roboto text-[0.9rem] font-normal text-[#1567A7] flex items-center"
                  onClick={() => toggleEditRecommendation(recommendation.id)}
                >
                  <img src={edit} alt="Edit" className="w-4 h-4 ml-1" /> Edit
                </div>
                <div
                  className="cursor-pointer font-roboto text-[0.9rem] font-normal text-brand-red flex items-center"
                  onClick={() => deleteRecommendation(recommendation.id)}
                >
                  <img src={trash} alt="Delete" className="w-4 h-4 ml-1" />{" "}
                  Delete
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default CommentSection;
